import gql from "graphql-tag";

export const m_CreateCheckoutSession = gql`
  mutation CreateCheckoutSession($input: CreateCheckoutSessionRequestInput!) {
    CreateCheckoutSession(input: $input) {
      redirectUrl
    }
  }
`;
